import React, { useState } from 'react';
import { Column } from 'react-table';
import { message } from 'antd';
import SearchListModal from '../../SearchListModal/SearchListModal';
import { ColumnUtilType, Option, SearchOption, TableListData } from '../../../types/common/table';

export interface LinkItemProps<T, F> {
  queryKey: string[];
  value?: T;
  validateItem?: (item: T) => { message: string } | null;
  columns: (utils: ColumnUtilType<T, F>) => Column<T>[];
  fetcher: (option: SearchOption<F>) => Promise<TableListData<T>>;
  onChange?: (selected: T) => void;
  initialOption?: Option<F>;
  trigger: (openModal: () => void) => JSX.Element;
}

const LinkItem = <T extends { id: number }, F extends Record<string, unknown>>(props: LinkItemProps<T, F>) => {
  const { value, validateItem, trigger, onChange, ...listProps } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = (selectedList: T[]): void => {
    const target = selectedList[0];
    const error = validateItem && validateItem(target);

    if (error) {
      message.error(error.message);
      return;
    }

    onChange && onChange(target);
    setIsModalOpen(false);
  };

  return (
    <>
      {trigger(() => setIsModalOpen(true))}
      {isModalOpen && (
        <SearchListModal
          isOpen={true}
          onOk={handleOk}
          onClose={() => setIsModalOpen(false)}
          value={value && [value]}
          {...listProps}
        />
      )}
    </>
  );
};

export default LinkItem;
